<template>
  <div class="container">
    <div class="main-pic">
      <img src="@/assets/image/mobile/mainpic.jpg">
    </div>
    <div class="intro">{{companyInfo.coverIntro}}</div>
    <div class="product">
      <div class="pd-header">
        <div class="pd-title">产品中心</div>
        <div class="l--l" style="border:0.4vw solid #fff;margin: 0 0 2.4vw"></div>
        <div class="pd-title-en">PRODUCT CENTER</div>
      </div>
      <el-carousel class="el-carousel" :interval="5000" height="48vw" arrow="always">
        <el-carousel-item v-for="(item,key) in productInfo" :key="key">
          <!--               @click="$router.push({path: '/mobileProductDetail',query: {id: key}})"-->
          <div class="pd-pic"
               @click="toDetail(item.id,item.itemIntro)">
            <img :src="$img + item.itemMobileHomeCover">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="pd-btn" @click="toProductCenter()">
        MORE
      </div>
    </div>
    <div class="service">
      <div class="sv-header">
        <div class="sv-title">我们为您提供的服务</div>
        <div class="sv-title-en">SERVICE SUPPORT</div>
        <div class="l--l"></div>
      </div>

      <div class="sv-item" :style="{'transform':(svBoxHover==key?'scale(0.9)':'')},key==0?svBox1Init:key==1?svBox2Init:svBox3Init"
           @touchstart="svBoxStart(key)" @touchend="svBoxEnd()"
           v-for="(item,key) in serviceItem" :key="key"
           @click="$router.push({path: '/mobile_service',query: {id: key}})">
        <img :src="$img + item.coverImg">
        <div>{{item.title}}</div>
      </div>
    </div>
    <div class="contact">
      <div class="sv-header">
        <div class="sv-title">您可以通过以下表单和我们联系</div>
        <div class="sv-title-en">FILL IN INFORMATION</div>
        <div class="l--l"></div>
      </div>
      <div class="form-container":style="{'top':(formInit?'0':''),'opacity':(formInit?1:'')}">
        <el-form :model="form" ref="form" :show-message="false">
          <el-form-item style="margin-bottom: 8px"
                        prop="name"
                        :rules="[{required:true}]">
            <el-input v-model="form.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px"
                        prop="phone"
                        :rules="[{required:true,pattern:/^1[34578]\d{9}$/,
                        trigger: ['blur', 'change']}]">
            <el-input v-model.number="form.phone" placeholder="电话"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px">
            <el-input v-model="form.wechat" placeholder="微信"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px"
                        prop="mail"
                        :rules="[{ required:true,type: 'email', trigger: ['blur', 'change'] }]">
            <el-input v-model="form.mail" placeholder="邮箱"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px"
                        prop="mark"
                        :rules="[{required:true}]">
            <el-input type="textarea" v-model="form.mark" placeholder="留言信息"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="submit-btn" @click="onSubmit(form)">提交信息</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="partner">
      <div class="partner-box">
        <el-carousel height="16vw" :interval="5000">
          <el-carousel-item v-for="(group,key) in partnerGroup" :key="key">
            <div class="el-carousel-item">
              <div class="pn-logo" v-for="item in group">
                <img :src="$img + item.companyLogo">
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="pn-black"></div>
    </div>
    <mbFooter></mbFooter>
  </div>
</template>

<script>
  import mbFooter from "../../components/mobile/mbFooter";

  export default {
    name: "mobile",
    components: {mbFooter},
    data() {
      return {
        form: {
          name: '',
          phone: '',
          wechat: '',
          mail: '',
          mark: ''
        },
        svBoxHover:-1,
        svBox1Init:{
          top:'56vw',
          opacity:0
        },
        svBox2Init:{
          top:'56vw',
          opacity:0
        },
        svBox3Init:{
          top:'56vw',
          opacity:0
        },
        formInit:false,
        partner:[],
        partnerGroup:[],//分组后的Partner
        companyInfo:{}, //公司信息
        serviceItem:[],  //服务项目
        productInfo:[], //产品信息
        screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      }
    },
    created() {
      if (this.screenWidth > 768) {
        this.$router.push('/')
      }
      this.$http.get('/api/company/info/list').then((res)=>{
        this.companyInfo = res.data.rows[0]
      })
      this.$http.get('/api/partner/info/list').then((res)=>{
        this.partner = res.data.rows
        let groupSize = 4   //每行显示的logo数
        let groupCount = Math.ceil(this.partner.length/groupSize)  //行数
        for (let i = 0;i < groupCount; i++){
          this.partnerGroup[i]=[]
          for (let k = 0;k < groupSize;k++){
            if (this.partner[k+i*groupSize] == undefined)
              continue
            this.partnerGroup[i].push(this.partner[k+i*groupSize])
          }
        }
      })
      this.$http.get('/api/skills/info/list').then((res)=>{
        this.serviceItem = res.data.rows
      })
      this.$http.get('/api/item/info/list',{params:{pageSize:3,pageNum:1}}).then((res)=>{
        this.productInfo = res.data.rows
      })
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll, true);
    },
    methods:{
      toDetail(id,itemIntro) {    //跳转详情页
        this.$router.push({
          path: '/mobileProductDetail',
          query: {id,itemIntro}
        })
      },
      onSubmit(form) {
        //提交表单
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http.post('/api/leaveWord/info', this.form).then((res) => {
              console.log(res)
              if (res.data.code === 200) {
                this.$message('提交成功')
                // this.open()
                console.log(res.data.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      svBoxStart(id) {
        this.svBoxHover=id
      },
      svBoxEnd(id) {
        this.svBoxHover=id
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop>350){
          this.svBox1Init.top='0vw'
          this.svBox1Init.opacity=1
        }
        if (scrollTop>600){
          this.svBox2Init.top='0vw'
          this.svBox2Init.opacity=1
        }
        if (scrollTop>900){
          this.svBox3Init.top='0vw'
          this.svBox3Init.opacity=1
        }
        if (scrollTop>1200){
          this.formInit=true
        }
      },
      toProductCenter() {
        this.$router.push('/mobile_product')
        document.documentElement.scrollTop=0
        document.body.scrollTop=0
      }
    }
  }
</script>

<style scoped>
  .container {
    overflow: hidden;
    width: 100vw;
  }

  .main-pic img {
    width: 100vw;
    /*margin-top: 12vw;*/
  }

  .title {
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
    margin-top: 8vw;
  }

  .l--l {
    width: 4vw;
    border: 0.4vw solid #6676e7;
    border-radius: 2em;
    margin: 2.4vw auto 4.8vw;
  }

  .intro {
    font-size: 0.75em;
    color: #768087;
    padding: 12vw 7vw 12vw;
    text-indent: 2em;
    line-height: 160%;
  }

  .product {
    background-image: url("../../assets/image/mobile/product-bg.jpg");
    background-size: 100vw;
    background-repeat: no-repeat;
    /*height: 100vw;*/
  }

  .pd-header {
    padding: 6.4vw 4.8vw 9.6vw;
    color: #fff;
    letter-spacing: 0.05em;
  }

  .pd-title {
    padding-bottom: 4.8vw;
    font-weight: bold;
  }

  .pd-title-en {
    font-size: .875em;
  }

  .el-carousel {
    width: 100vw;
    /*display: flex;*/
    /*height: 300px;*/
    /*height: 57vw;*/
  }

  .pd-pic {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .pd-pic img {
    width: 84vw;
    height: 48vw;
  }

  .pd-btn {
    width: 20vw;
    height: 7.2vw;
    border: 0.5px solid #888;
    line-height: 7.2vw;
    text-align: center;
    margin: 0 auto;
    font-size: 0.75em;
    /*150 54 888 1*/
    transition: transform .5s;
  }
  .pd-btn:hover{
    transform: scale(1.01);
  }

  .sv-title {
    font-weight: bold;
    text-align: center;
    margin: 15vw 0 2.4vw;
  }

  .sv-title-en {
    color: #888;
    font-size: 0.62em;
    text-align: center;
  }

  .sv-item {
    width: 56vw;
    margin: 0 auto;
    transition: transform .2s,top 1s,opacity 1s;
    position: relative;
    /*top: 56vw;*/
    /*opacity: 0;*/
  }
  .sv-item img {
    width: 56vw;
  }

  .sv-item div {
    margin: 4vw auto 8vw;
    text-align: center;
    font-size: 0.75em;
  }

  .form-container {
    padding: 0 12vw;
    position: relative;
    top: 600px;
    opacity: 0.1;
    transition: all 1s;
  }

  .submit-btn {
    width: 22.4vw;
    height: 8vw;
    background-color: #6676e7;
    color: #fff;
    font-size: 0.75em;
    line-height: 8vw;
    text-align: center;
    margin: 9px auto 0;
    border-radius: 2em;
  }

  .partner {
    /*height: 24.8vw;*/
    height: 16.8vw;
    margin-top: 8vw;
    /*background-color: #1c1b21;*/
    position: relative;
  }

  /*black 14.4*/
  .partner-box {
    /*width: 92vw;*/
    width: 88vw;
    height: 16vw;
    background-color: #f5f5f5;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-carousel {
    /*width: 88vw;*/
  }

  .el-carousel-item {
    width: 88vw;
    height: 16vw;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pn-black {
    height: 7vw;
    /*height: 14.4vw;*/
    width: 100vw;
    background-color: #1c1b21;
    position: absolute;
    bottom: -1px;
    /*left: 50%;*/
    z-index: -1;
  }

  .pn-logo {
    width: 16vw;
    height: 10vw;
    /*background-color: #333;*/
    margin: 0 2vw;
  }

  .pn-logo img {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/mobile.vue